import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { toast } from 'sonner';

const GoogleAuthCallback = ({ setUser }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const processGoogleCallback = async () => {
      try {
        const exchangeCode = searchParams.get('code');
        const errorParam = searchParams.get('error');

        if (errorParam) {
          throw new Error(`Google Sign In error: ${errorParam}`);
        }

        if (exchangeCode) {
          // Exchange the code for token
          const response = await axios.post(`${API}/auth/google/exchange`, {
            code: exchangeCode
          });
          
          if (response.data.token && response.data.user) {
            localStorage.setItem('token', response.data.token);
            if (setUser) setUser(response.data.user);
            toast.success(`Welcome, ${response.data.user.name}!`);
            
            // Check for pending review
            const pendingReview = sessionStorage.getItem('pendingReview');
            if (pendingReview) {
              try {
                const reviewData = JSON.parse(pendingReview);
                await axios.post(`${API}/reviews`, {
                  restaurant_name: reviewData.restaurant_name,
                  address: reviewData.address,
                  phone: reviewData.phone,
                  city: reviewData.city,
                  state: reviewData.state,
                  overall_rating: reviewData.overall_rating,
                  general_condition: parseInt(reviewData.general_condition),
                  supplies: parseInt(reviewData.supplies),
                  maintenance: parseInt(reviewData.maintenance),
                  restroom_types: reviewData.restroom_types,
                  comments: reviewData.comments,
                  fun_url: reviewData.fun_url || ''
                }, {
                  headers: { Authorization: `Bearer ${response.data.token}` }
                });
                sessionStorage.removeItem('pendingReview');
                toast.success('Your review has been submitted!');
              } catch (e) {
                console.error('Failed to submit pending review:', e);
              }
            }
            
            navigate('/');
            return;
          }
        }

        throw new Error('Authentication failed. Please try again.');
        
      } catch (err) {
        console.error('Google auth error:', err);
        setError(err.message || 'Google Sign In failed');
        toast.error(err.message || 'Google Sign In failed');
        setTimeout(() => navigate('/auth'), 3000);
      }
    };

    processGoogleCallback();
  }, [navigate, setUser, searchParams]);

  if (error) {
    return (
      <div className="min-h-screen toilet-humor-bg flex items-center justify-center">
        <div className="text-center p-8 bg-white rounded-lg border-4 border-black max-w-md">
          <div className="text-4xl mb-4">❌</div>
          <h2 className="text-2xl font-bold text-red-600 mb-4" style={{ fontFamily: 'Fredoka, sans-serif' }}>
            Sign In Failed
          </h2>
          <p className="text-gray-700 mb-4" style={{ fontFamily: 'Fredoka, sans-serif' }}>
            {error}
          </p>
          <p className="text-gray-500 text-sm" style={{ fontFamily: 'Fredoka, sans-serif' }}>
            Redirecting to login page...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen toilet-humor-bg flex items-center justify-center">
      <div className="text-center">
        <div className="text-2xl font-bold text-red-600 mb-4" style={{ fontFamily: 'Fredoka, sans-serif' }}>
          Processing Google Sign In...
        </div>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto"></div>
      </div>
    </div>
  );
};

export default GoogleAuthCallback;
